// extracted by mini-css-extract-plugin
export default {"SSOButton":"SSOButton_SSOButton__S9SvQ","spinner":"SSOButton_spinner__U+vA2"};